import { useContext, useEffect, useState } from "react";
import { API } from "../../../api";
import { Robot } from "../../../models";
import { UserContext } from "../../../hooks/UserContext";

export const useRobotsViewModel = () => {
	const currentUser = useContext(UserContext);
	const isDeveloper = currentUser?.isDeveloper ?? false;

	const [robots, setRobots] = useState<Robot[]>([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		if (!isDeveloper) return;

		const fetchRobots = async () => {
			setLoading(true);
			setError(null);
			try {
				const result = await API.Data.Robots.get.all();
				setRobots(result);
			} catch (err: any) {
				setError(`Failed to load robots: ${err.message || "Unknown error"}`);
			} finally {
				setLoading(false);
			}
		};

		fetchRobots();
	}, [isDeveloper]);

	return { isDeveloper, robots, loading, error };
};
